function getResultViaAjax(url, $areaToApplyResult, callback) {
    $.ajax({
        url: url,
        success: function (result) {
            $areaToApplyResult.html(result);
            if(callback)
                callback();
        }
    });
}

window.getResultViaAjax = getResultViaAjax;